export function mergeKit(data) {
    return new Promise((resolve, reject) => {
		let { mergeKitRequest, mergeKitError, mergeKitResult } = this.props;

		this.doAction(
			this.WEB_REQUEST_URL + 'merge_kit',
			this.createBundle(
				'merge_kit',
				{ data: data },
				this.POST,
				mergeKitRequest,
                (result) => {
                    mergeKitResult(result)
                    resolve(result)
                },
                (error) => {
                    mergeKitError(error)
                    reject(error)
                }
			)
		);
	})
}
